export const translations = {
  ro: {
    // Navbar
    navbar: {
      home: 'Acasă',
      language: 'Română',
      allCategories: 'Categorii',
      search: 'Caută produse...',
      infoDesc: 'Ai nevoie de ajutor ?',
      account: 'Contul meu',
      loginNow: 'Loghează-te',
      login: 'Autentificare',
      logout: 'Deconectare',
      cart: 'Coș',
      items: '- Articole',
      support: 'L - S: 08:00 - 20:00',
      termsAndConditions: 'Termeni și condiții',
      privacyPolicy: 'Politica de confidențialitate'
    },

    // Homepage
    home: {
      heroTitle: 'Reduceri de până la',
      heroSubtitle: 'Tehnologie inovatoare la prețuri accesibile',
      shopNow: 'Cumpără acum',
      trending: 'Tendințe',
      bestSeller: 'Best Seller',
      newArrival: 'Nou sosit',
      sale: 'Reducere',
      hotPicks: 'Oferte Fierbinți Astăzi',
      viewAll: 'Vezi toate',
      seeMore: 'Vezi mai multe',
      addToCart: 'Adaugă în coș',
      viewDetails: 'Vezi detalii',
      inStock: 'În stoc',
      outOfStock: 'Stoc epuizat',
      readMore: 'Citește mai mult'
    },

    // Product
    product: {
      price: 'Preț',
      originalPrice: 'Preț original',
      discount: 'Reducere',
      availability: 'Disponibilitate',
      inStock: 'În stoc',
      outOfStock: 'Stoc epuizat',
      selectColor: 'Selectează culoarea',
      selectSize: 'Selectează mărimea',
      quantity: 'Cantitate',
      addToCart: 'Adaugă în coș',
      buyNow: 'Cumpără acum',
      description: 'Descriere',
      specifications: 'Specificații',
      reviews: 'Recenzii',
      relatedProducts: 'Produse similare',
      payInInstallments: 'Achită în 3 rate',
      installmentsDescription: 'Plătește în 3 rate fără dobândă',
      writeReview: 'Scrie o recenzie',
      yourName: 'Numele tău',
      yourEmail: 'Email-ul tău',
      yourRating: 'Rating-ul tău',
      yourComment: 'Comentariul tău',
      submitReview: 'Trimite recenzia'
    },

    // Cart
    cart: {
      title: 'Coșul meu',
      empty: 'Coșul tău este gol',
      continueShopping: 'Continuă cumpărăturile',
      item: 'Produs',
      price: 'Preț',
      quantity: 'Cantitate',
      total: 'Total',
      subtotal: 'Subtotal',
      shipping: 'Livrare',
      freeShipping: 'Livrare gratuită',
      grandTotal: 'Total de plată',
      proceedToCheckout: 'Mergi la checkout',
      remove: 'Șterge',
      update: 'Actualizează'
    },

    // Checkout
    checkout: {
      title: 'Finalizare comandă',
      shippingAddress: 'Adresa de livrare',
      fullName: 'Nume complet',
      phone: 'Telefon',
      email: 'Email',
      address: 'Adresă',
      city: 'Oraș',
      postalCode: 'Cod poștal',
      paymentMethod: 'Metodă de plată',
      cashOnDelivery: 'Plată la livrare',
      cardPayment: 'Plată cu cardul',
      orderSummary: 'Sumar comandă',
      placeOrder: 'Plasează comanda',
      processing: 'Se procesează...',
    },

    // Footer
    footer: {
      aboutUs: 'AgroSmart este magazinul tău online cu produse pentru gospodărie, grădinărit și bricolaj, oferind unelte și utilaje la prețuri accesibile, cu livrare în toată țara.',
      menuFirst: 'Link-uri utile',
      menuSecond: 'Informații',
      menuThird: 'Categorii',
      contactUs: 'Contacte',
      termsAndConditions: 'Termeni și condiții',
      privacyPolicy: 'Politica de confidențialitate',
      call: 'Sună:',
      newsletter: 'Abonează-te la noutăți',
      newsletterDesc: 'Abonează-te la lista noastră de email pentru noutăți, actualizări și oferte exclusive.',
      newsletterText: 'Adresa de email',
      subscribe: 'Abonează-te',
      allRightsReserved: 'Powered by',
      address: 'or. Durleşti, str. Tudor Vladimirescu 70B',
      links: {
        about: 'Despre Noi',
        catalog: 'Catalog',
        services: 'Servicii',
        brands: 'Branduri',
        contacts: 'Contacte',
        terms: 'Termeni și conditii',
        policy: 'Politica de conf.',
        policyCookie: 'Politica Cookie',
        shipping: 'Livrare și plata',
        faq: 'Întrebări frecvente',
        allProducts: 'Toate produsele',
        saleProducts: 'Produse cu reducere',
        bestProducts: 'Cele mai vândute',
        newProducts: 'Produse noi'
      }
    },

    // Contact Page
    contact: {
      title: 'Contactează-ne',
      desc: 'Suntem aici să te ajutăm! Trimite-ne un mesaj.',

      breadcrumb: {
        home: 'Acasă',
        page: 'Contact'
      },

      cards: {
        address: 'Adresă',
        phone: 'Telefon',
        email: 'Email'
      },

      socialTitle: 'Urmărește-ne',

      form: {
        title: 'Trimite-ne un mesaj!',
        name: 'Nume *',
        email: 'Email *',
        phone: 'Telefon',
        subject: 'Subiect *',
        message: 'Mesaj *',

        placeholderName: 'Numele tău',
        placeholderEmail: 'email@exemplu.com',
        placeholderPhone: '+373 69 123 456',
        placeholderSubject: 'Subiectul mesajului',
        placeholderMessage: 'Scrie mesajul tău aici...',

        send: 'Trimite',
        sending: 'Se trimite...'
      },

      schedule: 'Program',
      social: 'Social Media',

      success: 'Mesajul tău a fost trimis. Îți vom răspunde în curând!',
      error: 'Nu s-a putut trimite mesajul. Te rog încearcă din nou.'
    },

    // Search
    search: {
      title: 'Rezultate căutare',
      noResults: 'Nu au fost găsite produse',
      searchFor: 'Rezultate pentru',
      results: 'rezultate',
      sortBy: 'Sortează după',
      priceAsc: 'Preț crescător',
      priceDesc: 'Preț descrescător',
      newest: 'Cele mai noi',
      popular: 'Popularitate'
    },

    // Account
    account: {
      myAccount: 'Contul meu',
      orders: 'Comenzile mele',
      profile: 'Profil',
      logout: 'Deconectare',
      editProfile: 'Editează profilul',
      saveChanges: 'Salvează modificările',
      orderHistory: 'Istoric comenzi',
      noOrders: 'Nu ai comenzi încă',
      orderNumber: 'Comandă',
      orderDate: 'Dată',
      orderStatus: 'Status',
      orderTotal: 'Total'
    },

    // Common
    common: {
      loading: 'Se încarcă...',
      error: 'Eroare',
      success: 'Succes',
      cancel: 'Anulează',
      confirm: 'Confirmă',
      save: 'Salvează',
      delete: 'Șterge',
      edit: 'Editează',
      close: 'Închide',
      yes: 'Da',
      no: 'Nu',
      back: 'Înapoi',
      next: 'Înainte',
      previous: 'Anterior',
      mdl: 'MDL'
    },

    // 404
    notfound: {
      title: 'Ups... pagina nu există.',
      desc: 'Se pare că pagina pe care o cauți nu a fost găsită. Revino pe pagina principală sau contactează-ne pentru ajutor.'
    },

    // FAQPage
    faq: {
      mainTitle: 'Întrebări frecvente',
      mainDesc: 'Găsește rapid răspunsurile la cele mai comune întrebări',
      breadcrumb: {
        home: 'Acasă',
        page: 'Întrebări frecvente'
      },
      title: 'Răspunsuri utile, clar explicate',
      desc: 'Am adunat cele mai importante întrebări pentru ca tu să găsești rapid informațiile de care ai nevoie.'
    },

    // Dynamic Page
    dynamic: {
      home: 'Acasă',
      desc: 'Informații și detalii despre AgroSmart'
    },

    // Brands Page
    brands: {
      title: 'Branduri',
      desc: 'Descoperă toate brandurile disponibile',
      breadcrumb: {
        home: 'Acasă',
        page: 'Branduri'
      },
      noneTitle: 'Niciun brand disponibil',
      noneDesc: 'Brandurile vor apărea aici când vor fi adăugate.',
      mainTitle: 'Toate brandurile',
      mainDesc: 'branduri disponibile'
    },

    // About Us Page
    about: {
      heroTitle: 'Despre Noi',
      heroDesc: 'Află mai multe despre compania noastră',
      breadcrumb: {
        home: 'Acasă',
        page: 'Despre Noi'
      },
      mainTitle: 'Soluții complete pentru confortul casei tale',
      missionTitle: 'Misiunea noastră',
      missionDesc: 'Misiunea noastră este să oferim produse de calitate pentru încălzire, apă și climatizare, la prețuri accesibile. Ne dorim să ajutăm fiecare client să găsească soluții eficiente și durabile pentru locuința sa, fără compromisuri.',
      visionTitle: 'Viziunea noastră',
      visionDesc: 'Ne propunem să devenim unul dintre cele mai de încredere magazine online din Moldova în domeniul instalațiilor, oferind produse moderne, livrare rapidă și suport profesionist pentru fiecare client.',
      stats: {
        experience: 'Ani de experiență',
        clients: 'Clienți mulțumiți',
        products: 'Produse disponibile',
        support: 'Suport și consultanță'
      },
      qualityTitle: 'Calitatea este prioritatea noastră',
      qualityDesc: 'Produse sigure, eficiente și durabile pentru fiecare proiect.',
      priorities: {
        fastDelivery: 'Livrare rapidă',
        fastDeliveryDesc: 'Expediem comenzile în cel mai scurt timp, direct la ușa ta.',
        consulting: 'Consultanță profesională',
        consultingDesc: 'Te ajutăm să alegi produsele potrivite pentru nevoile tale.',
        price: 'Prețuri accesibile',
        priceDesc: 'Oferim raport excelent calitate-preț pentru toate produsele.'
      },
      productsTitle: 'Tot ce ai nevoie pentru instalații, într-un singur loc',
      productsDesc: 'La AgroSmart găsești o gamă variată de produse pentru încălzire, apă, climatizare și instalații. Indiferent dacă lucrezi la o construcție nouă sau la renovare, avem soluții potrivite pentru fiecare proiect.',
      features: {
        item1: 'Încălzire și ACM – centrale, radiatoare și accesorii',
        item2: 'Obiecte sanitare moderne pentru baie și bucătărie',
        item3: 'Aer condiționat și sisteme de ventilare',
        item4: 'Țevi, fitinguri și componente pentru instalații'
      },
      productsDesc2: 'Alege AgroSmart pentru produse de încredere, livrare rapidă și prețuri corecte. Indiferent de proiect, îți oferim soluțiile potrivite, simplu și eficient.',
      testimonialsTitle: 'Ce spun clienții despre noi',
      testimonialsDesc: 'Feedback real de la clienți care au ales AgroSmart',
      whyTitle: 'De ce să alegi AgroSmart?',
      whyDesc: 'Cu peste 15 ani de experiență, oferim produse de încredere, livrare rapidă și suport dedicat. Punem accent pe calitate și pe satisfacția clientului, pentru ca fiecare comandă să fie o experiență sigură și eficientă.',
      features2: {
        item1: 'Garanție produse',
        item2: 'Suport real, nu roboți',
        item3: 'Produse testate și verificate',
        item4: 'Livrare rapidă în toată Moldova'
      },
      verifiedClient: 'Client verificat',
      reviews: {
        verified: 'Client verificat',
        item1: {
          name: 'Andrei Ceban',
          time: '10:25, 12 Feb, 2026',
          text: 'Am comandat un radiator și câteva fitinguri, totul a ajuns rapid și bine ambalat. Calitatea produselor este foarte bună, iar prețurile sunt chiar ok comparativ cu alte magazine.',
        },
        item2: {
          name: 'Natalia Rusu',
          time: '14:10, 18 Dec, 2026',
          text: 'Mi-a plăcut foarte mult că am primit ajutor la alegerea produselor. Nu eram sigură ce să aleg pentru baie, dar consultanța a fost foarte utilă. Recomand AgroSmart fără dubii.',
        },
        item3: {
          name: 'Sergiu Balan',
          time: '09:40, 3 Ian, 2026',
          text: 'Produse de calitate și livrare rapidă. Am comandat pentru un proiect de renovare și totul a fost exact cum trebuia. O să mai comand și pe viitor.',
        },
        item4: {
          name: 'Irina Munteanu',
          time: '17:55, 9 Iun, 2026',
          text: 'Site-ul este simplu de folosit, iar produsele sunt bine descrise. Comanda a venit în timp scurt și fără probleme. Foarte mulțumită de experiență.',
        },
        item5: {
          name: 'Vlad Cojocaru',
          time: '11:20, 15 Feb, 2026',
          text: 'Am cumpărat un aparat de aer condiționat și sunt foarte mulțumit. Livrarea a fost rapidă, iar produsul funcționează perfect. Se vede că lucrează profesionist.',
        },
        item6: {
          name: 'Elena Rotaru',
          time: '13:05, 22 Oct, 2026',
          text: 'Raport calitate-preț foarte bun. Am găsit tot ce aveam nevoie pentru instalații într-un singur loc. Simplu, rapid și fără complicații.',
        }
      }
    },

    // Services Page
    services: {
      title: 'Servicii',
      desc: 'Descoperă albumele cu lucrările și proiectele noastre',
      breadcrumb: {
        home: 'Acasă',
        page: 'Servicii'
      },
      empty: 'Niciun album disponibil momentan',
      albumsTitle: 'Albume servicii',
      albumsDesc: 'Apasă pe un album pentru a vedea imaginile din galerie',
      imagesCount: 'imagini',
      albumImages: 'imagini în acest album',
      back: 'Înapoi la servicii',
      lightboxImage: 'Imaginea',
      lightboxFrom: 'din'
    },

    // Catalog Page
    catalog: {
      title: 'Catalog',
      desc: 'Explorează toate categoriile disponibile',
      loading: 'Se încarcă catalogul...',
      emptyTitle: 'Nu există categorii',
      emptyDesc: 'Momentan nu au fost găsite categorii în catalog.',
      subcategories: 'subcategorii'
    },

    // Catalog Category Page
    catalogCategory: {
      loading: 'Se încarcă categoria...',
      notFound: 'Categoria nu a fost găsită',
      back: 'Înapoi la catalog',
      desc: 'Explorează subcategoriile disponibile',
      breadcrumb: {
        home: 'Acasă',
        catalog: 'Catalog'
      },
      emptyTitle: 'Nu există subcategorii',
      emptyDesc: 'Această categorie nu are subcategorii disponibile.',
      products: 'produse'
    },

    // Category Page
    categoryPage: {
      loading: 'Se încarcă...',
      notFound: 'Categoria nu a fost găsită',
      backHome: 'Înapoi la Acasă',
      breadcrumb: {
        home: 'Acasă'
      },
      productsAvailable: 'produse disponibile',
      filters: 'Filtre',
      reset: 'Resetează',
      resetFilters: 'Resetează filtrele',
      price: 'Preț (MDL)',
      min: 'Min',
      max: 'Max',
      apply: 'Aplică',
      brand: 'Brand',
      empty: 'Nu există produse în această categorie',
      prev: 'Înapoi',
      next: 'Înainte',
      showing: 'Se afișează',
      from: 'din'
    },

    // Contul meu
    myAccount: {
      title: 'Contul meu',
      welcome: 'Bun venit,',
      breadcrumb: {
        home: 'Acasă',
        page: 'Contul meu'
      },
      authRequired: {
        title: 'Trebuie să te autentifici',
        desc: 'Pentru a accesa contul tău, autentifică-te mai întâi.',
        backHome: 'Înapoi Acasă'
      },
      tabs: {
        profile: 'Profilul Meu',
        orders: 'Comenzile Mele',
        favorites: 'Favorite',
        addresses: 'Adrese',
        settings: 'Setări',
        logout: 'Deconectare'
      },
      profile: {
        title: 'Informații Personale',
        edit: 'Editează',
        cancel: 'Anulează',
        firstName: 'Prenume',
        lastName: 'Nume',
        email: 'Email',
        emailNote: 'Email-ul nu poate fi modificat',
        phone: 'Telefon',
        address: 'Adresă',
        city: 'Oraș',
        postalCode: 'Cod Poștal',
        placeholderPhone: '+373 69 123 456',
        placeholderAddress: 'Str. Principală nr. 123',
        placeholderCity: 'Chișinău',
        placeholderPostalCode: 'MD-2001',
        save: 'Salvează Modificările'
      },
      orders: {
        title: 'Comenzile Mele',
        emptyTitle: 'Nicio comandă încă',
        emptyDesc: 'Nu ai plasat nicio comandă până acum.',
        startShopping: 'Începe Cumpărăturile',
        order: 'Comanda',
        product: 'produs',
        products: 'produse',
        productsLabel: 'Produse:',
        shippingAddress: 'Adresă livrare:',
        cashOnDelivery: 'Cash la curier'
      },
      addresses: {
        title: 'Adresele Mele',
        desc: 'Adresa ta principală este setată în profil.',
        viewProfile: 'Vezi Profilul'
      },
      favorites: {
        title: 'Produsele Mele Favorite',
        emptyTitle: 'Niciun produs favorit încă',
        emptyDesc: 'Adaugă produse la favorite apăsând pictograma inimă de pe cartela produsului sau pagina produsului.',
        startShopping: 'Descoperă Produse',
        remove: 'Elimină din favorite',
        view: 'Vezi Produsul',
        removed: 'Produs eliminat din favorite'
      },
      settings: {
        title: 'Setări Cont',
        changePassword: {
          title: 'Schimbă Parola',
          desc: 'Actualizează parola contului tău',
          action: 'Schimbă Parola'
        },
        notifications: {
          title: 'Notificări',
          desc: 'Gestionează preferințele de notificare',
          action: 'Configurează'
        },
        deleteAccount: {
          title: 'Șterge Contul',
          desc: 'Această acțiune este permanentă',
          action: 'Șterge Contul'
        }
      },
      status: {
        pending: 'În Așteptare',
        processing: 'În Procesare',
        shipped: 'Expediată',
        delivered: 'Livrată',
        cancelled: 'Anulată'
      },
      toast: {
        successTitle: 'Succes',
        successDesc: 'Profilul a fost actualizat!',
        errorTitle: 'Eroare',
        errorDesc: 'Nu s-a putut actualiza profilul',
        logoutTitle: 'Deconectat',
        logoutDesc: 'Te-ai deconectat cu succes'
      }
    },

    // Cart Page
    cart: {
      emptyTitle: 'Coșul tău este gol',
      emptyDesc: 'Adaugă produse pentru a continua cumpărăturile',
      continueShopping: 'Continuă cumpărăturile',
      title: 'Coșul meu',
      orderSummary: 'Sumar comandă',
      subtotal: 'Subtotal',
      products: 'produse',
      shipping: 'Livrare',
      freeShipping: 'Gratuită în raza orașului Chișinău',
      total: 'Total',
      checkout: 'Finalizează comanda',
      freeShippingNote: 'Livrare gratuită pentru comenzi peste 3000 MDL',
      freeReturnNote: 'Retur gratuit în 30 de zile',
      securePaymentNote: 'Plată securizată 100%'
    },

    // Checkout Page
    checkout: {
      title: 'Finalizare Comandă',
      desc: 'Completează detaliile pentru livrare',
      contactInfo: 'Informații Contact',
      shippingAddress: 'Adresă Livrare',
      paymentMethod: 'Metodă Plată',
      orderSummary: 'Sumar Comandă',
      fullName: 'Nume Complet *',
      phone: 'Telefon *',
      email: 'Email *',
      address: 'Adresă Completă *',
      city: 'Oraș *',
      postalCode: 'Cod Poștal',
      notes: 'Notițe Suplimentare (Opțional)',
      placeholderFullName: 'Ion Popescu',
      placeholderPhone: '+373 69 123 456',
      placeholderEmail: 'email@exemplu.com',
      placeholderAddress: 'Strada, Nr., Bloc, Apartament',
      placeholderCity: 'Chișinău',
      placeholderPostalCode: 'MD-2001',
      placeholderNotes: 'Instrucțiuni speciale pentru livrare...',
      cashOnDelivery: 'Cash la curier',
      cashOnDeliveryDesc: 'Plătește când primești comanda',
      cardOnDelivery: 'Card la curier',
      cardOnDeliveryDesc: 'Plătește cu cardul direct curierului la livrare',
      bankTransfer: 'Transfer bancar',
      bankTransferDesc: 'Achiți prin transfer bancar înainte de expediere; te contactăm cu datele facturii',
      size: 'Mărime',
      subtotal: 'Subtotal',
      shipping: 'Livrare',
      freeShipping: 'Gratuită în raza orașului Chișinău',
      total: 'Total',
      processing: 'Se procesează...',
      placeOrder: 'Plasează Comanda',
      termsText: 'Prin plasarea comenzii, accepți',
      termsLink: 'Termenii și Condițiile',
      termsSuffix: 'noastre',
      successTitle: 'Succes',
      successDesc: 'Comanda ta a fost plasată cu succes!',
      errorTitle: 'Eroare',
      errorDesc: 'Nu s-a putut plasa comanda. Te rog încearcă din nou.',
      thankYou: 'Mulțumim'
    },

    // Product Card
    productCard: {
      addedToCart: "Produs adăugat în coș!",
      addedToWishlist: "Produs adăugat la favorite!",
      removedFromWishlist: "Produs eliminat din favorite!",
      buy: "Cumpără",
      success: "Succes"
    },

    // Auth Modal
    auth: {
      loginTitle: "Autentificare",
      registerTitle: "Creează un cont",
      forgotTitle: "Ai uitat parola",
      firstName: "Prenume",
      lastName: "Nume",
      email: "Email",
      password: "Parolă",
      confirmPassword: "Confirmă parola",
      forgotPassword: "Ai uitat parola?",
      loginButton: "Conectează-te",
      registerButton: "Creează cont",
      resetPasswordButton: "Resetează parola",
      backToLogin: "Înapoi la autentificare",
      noAccount: "Nu ai cont?",
      createAccount: "Creează cont",
      alreadyHaveAccount: "Ai deja cont?",
      success: "Succes",
      error: "Eroare",
      loginSuccess: "Autentificare realizată cu succes!",
      registerSuccess: "Cont creat cu succes!",
      passwordsDoNotMatch: "Parolele nu coincid!",
      genericError: "A apărut o eroare. Încearcă din nou.",
      resetLinkSent: "Link de resetare trimis pe email!"
    },

    // Search Page
    search: {
      title: "Rezultate căutare",
      searching: "Se caută...",
      found: "Găsite",
      result: "rezultat",
      results: "rezultate",
      for: "pentru",
      filter: "Filtrează",
      allCategories: "Toate categoriile",
      noResultsTitle: "Niciun rezultat găsit",
      noResultsDesc: "Nu am găsit produse care să corespundă căutării tale pentru",
      backHome: "Înapoi la homepage"
    },

    // Order Success
    orderSuccess: {
      title: "Comandă plasată cu succes!",
      description: "Mulțumim pentru comandă!",
      nextTitle: "Ce urmează?",
      nextDesc: "Comanda ta va fi procesată în 24 de ore. Vei primi un SMS cu detaliile de livrare.",
      backHome: "Înapoi la acasă",
      viewOrders: "Vezi comenzile mele"
    },

    // Detail Products Page
    productDetail: {
      notFound: "Produs negăsit",
      backHome: "Înapoi la acasă",

      sku: "Codul produsului",
      reviews: "recenzii",
      sold: "vândute",

      quantity: "Cantitate",
      available: "în stoc",
      inStock: "În stoc",

      orderByPhone: "Comandă rapid",
      addToCart: "Adaugă în coș",
      buyNow: "Cumpără acum",

      installmentTitle: "Achită în 3 rate",
      perMonth: "/ lună",
      noInterest: "Fără dobândă • Fără comisioane",
      learnMore: "Află mai multe",

      freeDelivery: "Livrare gratuită",
      freeDeliveryDesc: "în raza orașului Chișinău",

      return: "Retur 30 zile",
      returnDesc: "Garanție returnare",

      securePayment: "Plată securizată",
      securePaymentDesc: "100% protejat",

      tabs: {
        description: "Descriere",
        specifications: "Specificații",
        reviews: "Recenzii"
      },

      noDescription: "Descriere disponibilă în curând.",
      noSpecifications: "Nicio specificație disponibilă",

      writeReview: "Scrie o recenzie",
      yourName: "Numele tău",
      email: "Email",
      rating: "Rating",
      comment: "Comentariu ..",
      commentPlaceholder: "Scrie recenzia ta ..",
      submitReview: "Trimite recenzia",
      submitting: "Se trimite...",
      reviewAdded: 'Recenzie adăugată cu succes',

      customerReviews: "Recenzii clienți",
      noReviews: "Nicio recenzie încă. Fii primul care evaluează acest produs!",

      relatedProducts: "Produse similare",

      installmentModal: {
        title: "Plata în rate",
        plan: "Plan de plată",
        total: "Preț total",
        monthly: "Rata lunară",
        schedule: "Calendar plăți",
        month: "Luna",
        request: "Trimite cerere",
        fullName: "Nume complet",
        phone: "Telefon",
        send: "Trimite cererea",
        success: "Cerere trimisă!",
        error: "Nu s-a putut trimite cererea. Te rog încearcă din nou.",
        note: "Vă vom contacta în cel mai scurt timp pentru a finaliza cererea de plată în rate.",

        benefits: {
          noInterest: "Fără dobândă",
          noFees: "Fără comisioane",
          fastApproval: "Aprobare rapidă",
          online: "100% online"
        }
      }
    },

    // Brand Category Page
    brandPage: {
      home: 'Acasă',
      brands: 'Branduri',
      brandNotFound: 'Brand-ul nu a fost găsit',
      loadError: 'Eroare la încărcarea datelor',
      backToBrands: 'Înapoi la Branduri',
      noProducts: 'Nu există produse disponibile pentru acest brand'
    },

    // Produse cu reducere
    discountProducts: "Produse cu reducere",
  },

  ru: {
    // Navbar
    navbar: {
      home: 'Главная',
      language: 'Русский',
      allCategories: 'Категории',
      search: 'Поиск товаров...',
      infoDesc: 'Нужна помощь?',
      account: 'Мой аккаунт',
      loginNow: 'Войти',
      login: 'Войти',
      logout: 'Выйти',
      cart: 'Корзина',
      items: '- Товары',
      support: 'П - С: 08:00 - 20:00',
      termsAndConditions: 'Условия и положения',
      privacyPolicy: 'Политика конфиденциальности'
    },

    // Homepage
    home: {
      heroTitle: 'Скидки до',
      heroSubtitle: 'Инновационные технологии по доступным ценам',
      shopNow: 'Купить сейчас',
      trending: 'Тренды',
      bestSeller: 'Бестселлер',
      newArrival: 'Новинка',
      sale: 'Распродажа',
      hotPicks: 'Горячие предложения сегодня',
      viewAll: 'Посмотреть все',
      seeMore: 'Узнать больше',
      addToCart: 'В корзину',
      viewDetails: 'Подробнее',
      inStock: 'В наличии',
      outOfStock: 'Нет в наличии',
      readMore: 'Читать далее'
    },

    // Product
    product: {
      price: 'Цена',
      originalPrice: 'Оригинальная цена',
      discount: 'Скидка',
      availability: 'Наличие',
      inStock: 'В наличии',
      outOfStock: 'Нет в наличии',
      selectColor: 'Выберите цвет',
      selectSize: 'Выберите размер',
      quantity: 'Количество',
      addToCart: 'В корзину',
      buyNow: 'Купить сейчас',
      description: 'Описание',
      specifications: 'Характеристики',
      reviews: 'Отзывы',
      relatedProducts: 'Похожие товары',
      payInInstallments: 'Оплата в 3 платежа',
      installmentsDescription: 'Платите в 3 платежа без процентов',
      writeReview: 'Написать отзыв',
      yourName: 'Ваше имя',
      yourEmail: 'Ваш email',
      yourRating: 'Ваша оценка',
      yourComment: 'Ваш комментарий',
      submitReview: 'Отправить отзыв'
    },

    // Cart
    cart: {
      title: 'Моя корзина',
      empty: 'Ваша корзина пуста',
      continueShopping: 'Продолжить покупки',
      item: 'Товар',
      price: 'Цена',
      quantity: 'Количество',
      total: 'Итого',
      subtotal: 'Промежуточный итог',
      shipping: 'Доставка',
      freeShipping: 'Бесплатно в пределах города Кишинёв',
      grandTotal: 'Общая сумма',
      proceedToCheckout: 'Перейти к оформлению',
      remove: 'Удалить',
      update: 'Обновить'
    },

    // Checkout
    checkout: {
      title: 'Оформление заказа',
      shippingAddress: 'Адрес доставки',
      fullName: 'Полное имя',
      phone: 'Телефон',
      email: 'Email',
      address: 'Адрес',
      city: 'Город',
      postalCode: 'Почтовый индекс',
      paymentMethod: 'Способ оплаты',
      cashOnDelivery: 'Оплата при получении',
      cardPayment: 'Оплата картой',
      orderSummary: 'Сводка заказа',
      placeOrder: 'Разместить заказ',
      processing: 'Обработка...'
    },

    footer: {
      aboutUs: 'AgroSmart.md — это ваш интернет-магазин товаров для дома, садоводства и ремонта, предлагающий инструменты и оборудование по доступным ценам с доставкой по всей стране.',
      menuFirst: 'Полезные ссылки',
      menuSecond: 'Информация',
      menuThird: 'Категории',
      contactUs: 'Контакты',
      termsAndConditions: 'Условия и положения',
      privacyPolicy: 'Политика конфиденциальности',
      call: 'Позвоните:',
      newsletter: 'Подпишитесь на новости',
      newsletterDesc: 'Подпишитесь на нашу рассылку, чтобы получать новости, обновления и эксклюзивные предложения.',
      newsletterText: 'Адрес электронной почты',
      subscribe: 'Подписаться',
      allRightsReserved: 'Создано',
      address: 'г. Дурлешты, ул. Тудор Владимиреску 70Б',
      links: {
        about: 'О нас',
        catalog: 'Каталог',
        services: 'Услуги',
        brands: 'Бренды',
        contacts: 'Контакты',
        terms: 'Условия и поло.',
        policy: 'Политика конф.',
        policyCookie: 'Политика Cookie',
        shipping: 'Доставка и оплата',
        faq: 'Вопросы и ответы',
        allProducts: 'Все товары',
        saleProducts: 'Товары со скидкой',
        bestProducts: 'Хиты продаж',
        newProducts: 'Новинки'
      }
    },

    // Contact Page
    contact: {
      title: 'Свяжитесь с нами',
      desc: 'Мы здесь, чтобы помочь вам! Отправьте нам сообщение.',

      breadcrumb: {
        home: 'Главная',
        page: 'Контакты'
      },

      cards: {
        address: 'Адрес',
        phone: 'Телефон',
        email: 'Электронная почта'
      },

      socialTitle: 'Подписывайтесь на нас',

      form: {
        title: 'Отправьте нам сообщение!',
        name: 'Имя *',
        email: 'Электронная почта *',
        phone: 'Телефон',
        subject: 'Тема *',
        message: 'Сообщение *',

        placeholderName: 'Ваше имя',
        placeholderEmail: 'email@пример.com',
        placeholderPhone: '+373 69 123 456',
        placeholderSubject: 'Тема сообщения',
        placeholderMessage: 'Напишите ваше сообщение...',

        send: 'Отправить',
        sending: 'Отправляется...'
      },

      schedule: 'График работы',
      social: 'Социальные сети',

      success: 'Ваше сообщение отправлено. Мы скоро свяжемся с вами!',
      error: 'Не удалось отправить сообщение. Попробуйте ещё раз.'
    },

    // Search
    search: {
      title: 'Результаты поиска',
      noResults: 'Товары не найдены',
      searchFor: 'Результаты для',
      results: 'результатов',
      sortBy: 'Сортировать по',
      priceAsc: 'Цена по возрастанию',
      priceDesc: 'Цена по убыванию',
      newest: 'Новые',
      popular: 'Популярность'
    },

    // Account
    account: {
      myAccount: 'Мой аккаунт',
      orders: 'Мои заказы',
      profile: 'Профиль',
      logout: 'Выйти',
      editProfile: 'Редактировать профиль',
      saveChanges: 'Сохранить изменения',
      orderHistory: 'История заказов',
      noOrders: 'У вас пока нет заказов',
      orderNumber: 'Заказ',
      orderDate: 'Дата',
      orderStatus: 'Статус',
      orderTotal: 'Итого'
    },

    // Common
    common: {
      loading: 'Загрузка...',
      error: 'Ошибка',
      success: 'Успех',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
      save: 'Сохранить',
      delete: 'Удалить',
      edit: 'Редактировать',
      close: 'Закрыть',
      yes: 'Да',
      no: 'Нет',
      back: 'Назад',
      next: 'Вперед',
      previous: 'Предыдущий',
      mdl: 'MDL'
    },

    // 404
    notfound: {
      title: 'Упс... страница не существует.',
      desc: 'Похоже, что страница, которую вы ищете, не найдена. Вернитесь на главную страницу или свяжитесь с нами для помощи.'
    },

    // FAQ
    faq: {
      mainTitle: 'Часто задаваемые вопросы',
      mainDesc: 'Быстро найдите ответы на самые распространённые вопросы',
      breadcrumb: {
        home: 'Главная',
        page: 'Часто задаваемые вопросы'
      },
      title: 'Полезные ответы, понятно объяснённые',
      desc: 'Мы собрали самые важные вопросы, чтобы вы могли быстро найти нужную информацию.'
    },

    // Dynamic Page
    dynamic: {
      home: 'Главная',
      desc: 'Информация и подробности о AgroSmart'
    },

    // Brands Page
    brands: {
      title: 'Бренды',
      desc: 'Откройте для себя все доступные бренды',
      breadcrumb: {
        home: 'Главная',
        page: 'Бренды'
      },
      noneTitle: 'Нет доступных брендов',
      noneDesc: 'Бренды появятся здесь, когда будут добавлены.',
      mainTitle: 'Все бренды',
      mainDesc: 'доступные бренды'
    },

    // About Us Page
    about: {
      heroTitle: 'О нас',
      heroDesc: 'Узнайте больше о нашей компании',
      breadcrumb: {
        home: 'Главная',
        page: 'О нас'
      },
      mainTitle: 'Комплексные решения для комфорта вашего дома',
      missionTitle: 'Наша миссия',
      missionDesc: 'Наша миссия — предоставлять качественные решения для отопления, водоснабжения и климатических систем по доступным ценам. Мы стремимся помочь каждому клиенту найти эффективные и долговечные решения для своего дома.',
      visionTitle: 'Наше видение',
      visionDesc: 'Мы стремимся стать одним из самых надежных интернет-магазинов в Молдове в сфере инженерных систем, предлагая современные товары, быструю доставку и профессиональную поддержку.',
      stats: {
        experience: 'Лет опыта',
        clients: 'Довольных клиентов',
        products: 'Доступных товаров',
        support: 'Поддержка и консультации'
      },
      qualityTitle: 'Качество — наш приоритет',
      qualityDesc: 'Надежные, эффективные и долговечные решения для каждого проекта.',
      priorities: {
        fastDelivery: 'Быстрая доставка',
        fastDeliveryDesc: 'Мы доставляем заказы в кратчайшие сроки прямо к вашей двери.',
        consulting: 'Профессиональная консультация',
        consultingDesc: 'Поможем выбрать подходящие товары для ваших задач.',
        price: 'Доступные цены',
        priceDesc: 'Отличное соотношение цены и качества для всех товаров.'
      },
      productsTitle: 'Все для инженерных систем в одном месте',
      productsDesc: 'В AgroSmart вы найдете широкий ассортимент товаров для отопления, водоснабжения, климатических систем и монтажа. Подходит как для нового строительства, так и для ремонта.',
      features: {
        item1: 'Отопление и ГВС — котлы, радиаторы и аксессуары',
        item2: 'Современная сантехника для ванной и кухни',
        item3: 'Кондиционирование и системы вентиляции',
        item4: 'Трубы, фитинги и комплектующие'
      },
      productsDesc2: 'Выбирайте AgroSmart — надежные товары, быстрая доставка и честные цены. Мы предлагаем оптимальные решения для любого проекта.',
      testimonialsTitle: 'Что говорят о нас клиенты',
      testimonialsDesc: 'Реальные отзывы клиентов, выбравших AgroSmart',
      whyTitle: 'Почему стоит выбрать AgroSmart?',
      whyDesc: 'Более 15 лет опыта, надежные товары, быстрая доставка и профессиональная поддержка. Мы ориентированы на качество и удовлетворенность клиентов.',
      features2: {
        item1: 'Гарантия на продукцию',
        item2: 'Живая поддержка, не боты',
        item3: 'Проверенные и качественные товары',
        item4: 'Быстрая доставка по всей Молдове'
      },
      verifiedClient: 'Проверенный клиент',
      reviews: {
        verified: 'Проверенный клиент',
        item1: {
          name: 'Андрей Чебан',
          time: '10:25, 12 фев, 2026',
          text: 'Заказал радиатор и несколько фитингов, всё пришло быстро и хорошо упаковано. Качество продукции отличное, а цены вполне адекватные по сравнению с другими магазинами.',
        },
        item2: {
          name: 'Наталия Русу',
          time: '14:10, 18 дек, 2026',
          text: 'Очень понравилось, что мне помогли с выбором товаров. Я не знала, что выбрать для ванной, но консультация была очень полезной. Рекомендую AgroSmart.',
        },
        item3: {
          name: 'Серджиу Балан',
          time: '09:40, 3 янв, 2026',
          text: 'Качественные товары и быстрая доставка. Заказывал для ремонта — всё пришло как нужно. Буду заказывать ещё.',
        },
        item4: {
          name: 'Ирина Мунтяну',
          time: '17:55, 9 июн, 2026',
          text: 'Сайт удобный, товары хорошо описаны. Заказ пришёл быстро и без проблем. Очень довольна.',
        },
        item5: {
          name: 'Влад Кожокару',
          time: '11:20, 15 фев, 2026',
          text: 'Купил кондиционер и остался очень доволен. Доставка быстрая, товар работает отлично. Видно, что работают профессионально.',
        },
        item6: {
          name: 'Елена Ротару',
          time: '13:05, 22 окт, 2026',
          text: 'Отличное соотношение цены и качества. Нашла всё, что нужно, в одном месте. Быстро и удобно.',
        }
      }
    },

    // Services Page
    services: {
      title: 'Услуги',
      desc: 'Откройте альбомы с нашими работами и проектами',
      breadcrumb: {
        home: 'Главная',
        page: 'Услуги'
      },
      empty: 'На данный момент нет доступных альбомов',
      albumsTitle: 'Альбомы услуг',
      albumsDesc: 'Нажмите на альбом, чтобы посмотреть изображения в галерее',
      imagesCount: 'изображений',
      albumImages: 'изображений в этом альбоме',
      back: 'Назад к услугам',
      lightboxImage: 'Изображение',
      lightboxFrom: 'из'
    },

    // Catalog Page
    catalog: {
      title: 'Каталог',
      desc: 'Изучите все доступные категории',
      loading: 'Загрузка каталога...',
      emptyTitle: 'Нет категорий',
      emptyDesc: 'На данный момент категории в каталоге не найдены.',
      subcategories: 'подкатегорий'
    },

    // Catalog Category Page
    catalogCategory: {
      loading: 'Загрузка категории...',
      notFound: 'Категория не найдена',
      back: 'Назад в каталог',
      desc: 'Изучите доступные подкатегории',
      breadcrumb: {
        home: 'Главная',
        catalog: 'Каталог'
      },
      emptyTitle: 'Нет подкатегорий',
      emptyDesc: 'В этой категории нет доступных подкатегорий.',
      products: 'товаров'
    },

    // Category Page
    categoryPage: {
      loading: 'Загрузка...',
      notFound: 'Категория не найдена',
      backHome: 'Назад на главную',
      breadcrumb: {
        home: 'Главная'
      },
      productsAvailable: 'товаров доступно',
      filters: 'Фильтры',
      reset: 'Сбросить',
      resetFilters: 'Сбросить фильтры',
      price: 'Цена (MDL)',
      min: 'Мин',
      max: 'Макс',
      apply: 'Применить',
      brand: 'Бренд',
      empty: 'В этой категории нет товаров',
      prev: 'Назад',
      next: 'Вперёд',
      showing: 'Показано',
      from: 'из'
    },

    // Contul meu
    myAccount: {
      title: 'Мой аккаунт',
      welcome: 'Добро пожаловать,',
      breadcrumb: {
        home: 'Главная',
        page: 'Мой аккаунт'
      },
      authRequired: {
        title: 'Необходимо войти в аккаунт',
        desc: 'Чтобы получить доступ к своему аккаунту, сначала выполните вход.',
        backHome: 'Назад на главную'
      },
      tabs: {
        profile: 'Мой профиль',
        orders: 'Мои заказы',
        favorites: 'Избранное',
        addresses: 'Адреса',
        settings: 'Настройки',
        logout: 'Выйти'
      },
      profile: {
        title: 'Личная информация',
        edit: 'Редактировать',
        cancel: 'Отмена',
        firstName: 'Имя',
        lastName: 'Фамилия',
        email: 'Email',
        emailNote: 'Email нельзя изменить',
        phone: 'Телефон',
        address: 'Адрес',
        city: 'Город',
        postalCode: 'Почтовый индекс',
        placeholderPhone: '+373 69 123 456',
        placeholderAddress: 'ул. Главная, 123',
        placeholderCity: 'Кишинёв',
        placeholderPostalCode: 'MD-2001',
        save: 'Сохранить изменения'
      },
      orders: {
        title: 'Мои заказы',
        emptyTitle: 'Заказов пока нет',
        emptyDesc: 'Вы ещё не оформили ни одного заказа.',
        startShopping: 'Начать покупки',
        order: 'Заказ',
        product: 'товар',
        products: 'товара',
        productsLabel: 'Товары:',
        shippingAddress: 'Адрес доставки:',
        cashOnDelivery: 'Наличными курьеру'
      },
      addresses: {
        title: 'Мои адреса',
        desc: 'Ваш основной адрес указан в профиле.',
        viewProfile: 'Посмотреть профиль'
      },
      favorites: {
        title: 'Избранные товары',
        emptyTitle: 'Пока нет избранных товаров',
        emptyDesc: 'Добавляйте товары в избранное, нажимая на иконку сердца на карточке товара или странице товара.',
        startShopping: 'Открыть товары',
        remove: 'Удалить из избранного',
        view: 'Посмотреть товар',
        removed: 'Товар удалён из избранного'
      },
      settings: {
        title: 'Настройки аккаунта',
        changePassword: {
          title: 'Сменить пароль',
          desc: 'Обновите пароль вашего аккаунта',
          action: 'Сменить пароль'
        },
        notifications: {
          title: 'Уведомления',
          desc: 'Управляйте настройками уведомлений',
          action: 'Настроить'
        },
        deleteAccount: {
          title: 'Удалить аккаунт',
          desc: 'Это действие необратимо',
          action: 'Удалить аккаунт'
        }
      },
      status: {
        pending: 'В ожидании',
        processing: 'В обработке',
        shipped: 'Отправлен',
        delivered: 'Доставлен',
        cancelled: 'Отменён'
      },
      toast: {
        successTitle: 'Успешно',
        successDesc: 'Профиль был обновлён!',
        errorTitle: 'Ошибка',
        errorDesc: 'Не удалось обновить профиль',
        logoutTitle: 'Выход выполнен',
        logoutDesc: 'Вы успешно вышли из аккаунта'
      }
    },

    // Cart Page
    cart: {
      emptyTitle: 'Ваша корзина пуста',
      emptyDesc: 'Добавьте товары, чтобы продолжить покупки',
      continueShopping: 'Продолжить покупки',
      title: 'Моя корзина',
      orderSummary: 'Сводка заказа',
      subtotal: 'Промежуточный итог',
      products: 'товаров',
      shipping: 'Доставка',
      freeShipping: 'Бесплатно в пределах города Кишинёв',
      total: 'Итого',
      checkout: 'Оформить заказ',
      freeShippingNote: 'Бесплатная доставка для заказов свыше 3000 MDL',
      freeReturnNote: 'Бесплатный возврат в течение 30 дней',
      securePaymentNote: '100% безопасная оплата'
    },

    // Checkout Page
    checkout: {
      title: 'Оформление заказа',
      desc: 'Заполните данные для доставки',
      contactInfo: 'Контактная информация',
      shippingAddress: 'Адрес доставки',
      paymentMethod: 'Способ оплаты',
      orderSummary: 'Сводка заказа',
      fullName: 'Полное имя *',
      phone: 'Телефон *',
      email: 'Email *',
      address: 'Полный адрес *',
      city: 'Город *',
      postalCode: 'Почтовый индекс',
      notes: 'Дополнительные примечания (необязательно)',
      placeholderFullName: 'Ион Попеску',
      placeholderPhone: '+373 69 123 456',
      placeholderEmail: 'email@пример.com',
      placeholderAddress: 'Улица, №, блок, квартира',
      placeholderCity: 'Кишинёв',
      placeholderPostalCode: 'MD-2001',
      placeholderNotes: 'Особые инструкции для доставки...',
      cashOnDelivery: 'Наличными курьеру',
      cashOnDeliveryDesc: 'Оплатите при получении заказа',
      cardOnDelivery: 'Картой курьеру',
      cardOnDeliveryDesc: 'Оплатите картой курьеру при получении',
      bankTransfer: 'Банковский перевод',
      bankTransferDesc: 'Оплата банковским переводом до отправки; свяжемся с реквизитами',
      size: 'Размер',
      subtotal: 'Промежуточный итог',
      shipping: 'Доставка',
      freeShipping: 'Бесплатно',
      total: 'Итого',
      processing: 'Обработка...',
      placeOrder: 'Оформить заказ',
      termsText: 'Оформляя заказ, вы принимаете наши',
      termsLink: 'Условия и положения',
      termsSuffix: '',
      successTitle: 'Успешно',
      successDesc: 'Ваш заказ был успешно оформлен!',
      errorTitle: 'Ошибка',
      errorDesc: 'Не удалось оформить заказ. Пожалуйста, попробуйте снова.',
      thankYou: 'Спасибо'
    },

    // Product Card
    productCard: {
      addedToCart: "Товар добавлен в корзину!",
      addedToWishlist: "Товар добавлен в избранное!",
      removedFromWishlist: "Товар удалён из избранного!",
      buy: "Купить",
      success: "Успешно"
    },

    // Auth Modal
    auth: {
      loginTitle: "Вход",
      registerTitle: "Создать аккаунт",
      forgotTitle: "Забыли пароль",
      firstName: "Имя",
      lastName: "Фамилия",
      email: "Email",
      password: "Пароль",
      confirmPassword: "Подтвердите пароль",
      forgotPassword: "Забыли пароль?",
      loginButton: "Войти",
      registerButton: "Создать аккаунт",
      resetPasswordButton: "Сбросить пароль",
      backToLogin: "Назад ко входу",
      noAccount: "Нет аккаунта?",
      createAccount: "Создать аккаунт",
      alreadyHaveAccount: "Уже есть аккаунт?",
      success: "Успешно",
      error: "Ошибка",
      loginSuccess: "Вход выполнен успешно!",
      registerSuccess: "Аккаунт успешно создан!",
      passwordsDoNotMatch: "Пароли не совпадают!",
      genericError: "Произошла ошибка. Попробуйте снова.",
      resetLinkSent: "Ссылка для сброса отправлена на email!"
    },

    // Search Page
    search: {
      title: "Результаты поиска",
      searching: "Поиск...",
      found: "Найдено",
      result: "результат",
      results: "результатов",
      for: "по запросу",
      filter: "Фильтр",
      allCategories: "Все категории",
      noResultsTitle: "Ничего не найдено",
      noResultsDesc: "Мы не нашли товары, соответствующие вашему запросу",
      backHome: "Вернуться на главную"
    },

    // Order Success
    orderSuccess: {
      title: "Заказ успешно оформлен!",
      description: "Спасибо за заказ!",
      nextTitle: "Что дальше?",
      nextDesc: "Ваш заказ будет обработан в течение 24 часов. Вы получите SMS с деталями доставки.",
      backHome: "На главную",
      viewOrders: "Мои заказы"
    },

    // Product Detail Page
    productDetail: {
      notFound: "Товар не найден",
      backHome: "На главную",

      sku: "Код товара",
      reviews: "отзывов",
      sold: "продано",

      quantity: "Количество",
      available: "в наличии",
      inStock: "Есть в наличии",

      orderByPhone: "Быстрый заказ",
      addToCart: "Добавить в корзину",
      buyNow: "Купить сейчас",

      installmentTitle: "Оплата в 3 рассрочки",
      perMonth: "/ месяц",
      noInterest: "Без процентов • Без комиссии",
      learnMore: "Узнать больше",

      freeDelivery: "Бесплатная доставка",
      freeDeliveryDesc: "в пределах города Кишинёв",

      return: "Возврат 30 дней",
      returnDesc: "Гарантия возврата",

      securePayment: "Безопасная оплата",
      securePaymentDesc: "100% защита",

      tabs: {
        description: "Описание",
        specifications: "Характеристики",
        reviews: "Отзывы"
      },

      noDescription: "Описание скоро будет доступно.",
      noSpecifications: "Нет доступных характеристик",

      writeReview: "Оставить отзыв",
      yourName: "Ваше имя",
      email: "Email",
      rating: "Оценка",
      comment: "Комментарий",
      commentPlaceholder: "Напишите ваш отзыв..",
      submitReview: "Отправить отзыв",
      submitting: "Отправка...",
      reviewAdded: 'Отзыв успешно добавлен',

      customerReviews: "Отзывы клиентов",
      noReviews: "Пока нет отзывов. Будьте первым!",

      relatedProducts: "Похожие товары",

      installmentModal: {
        title: "Оплата в рассрочку",
        plan: "План оплаты",
        total: "Общая сумма",
        monthly: "Ежемесячный платеж",
        schedule: "График платежей",
        month: "Месяц",
        request: "Отправить заявку",
        fullName: "Полное имя",
        phone: "Телефон",
        send: "Отправить заявку",
        success: "Заявка отправлена!",
        error: "Не удалось отправить заявку. Попробуйте снова.",
        note: "Мы свяжемся с вами в ближайшее время для завершения заявки.",

        benefits: {
          noInterest: "Без процентов",
          noFees: "Без комиссии",
          fastApproval: "Быстрое одобрение",
          online: "100% онлайн"
        }
      }
    },

    // Brand Category Page
    brandPage: {
      home: 'Главная',
      brands: 'Бренды',
      brandNotFound: 'Бренд не найден',
      loadError: 'Ошибка при загрузке данных',
      backToBrands: 'Назад к брендам',
      noProducts: 'Для этого бренда нет доступных товаров'
    },

    // Produse cu reducere
    discountProducts: "Товары со скидкой"
  }
};
